/**
 * Shared contract for MFE-initiated notifications rendered by the parent WFE.
 *
 * WFE already renders notifications fired by other MFEs (vehicle-status, notification-settings)
 * through a single handler in `MfeMessageHandler.jsx`. This `COMMON/SHOW_NOTIFICATION` event reuses
 * that handler's payload shape (`{ type, title?, description }`) so any MFE can trigger a toast
 * without WFE adding per-MFE cases. The MFE owns i18n, so `title`/`description` are already
 * localized; WFE displays them as-is.
 *
 * The type string is the authoritative cross-repo contract and must be used verbatim on the WFE
 * side. Migrating the legacy per-MFE SHOW_NOTIFICATION events onto this one is a separate ticket.
 */

// MFE → WFE
export const COMMON_SHOW_NOTIFICATION = 'COMMON/SHOW_NOTIFICATION';

export type NotificationType = 'ERROR' | 'SUCCESS';

export interface ShowNotificationPayload {
    type: NotificationType;
    /** Already-localized text — WFE displays it as-is. */
    description: string;
    /** Optional already-localized heading. */
    title?: string;
}
